import { defineAsyncComponent, type AsyncComponentLoader, type Component } from 'vue';

export default function asyncComponent(loader: AsyncComponentLoader): Component {
  return defineAsyncComponent(loader);
}
